
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalConeDown as ObiBuoySphericalConeDownElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-cone-down.js';
 
 
 

 
 export const ObiBuoySphericalConeDown = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-cone-down',
   elementClass: ObiBuoySphericalConeDownElement,
   events: {
     
   }
  });
 
 